import React from "react";
import { IDataCenter, IEscalationMatrix } from "../../vm";
import {
  getAllEscalationMatrix,
  deleteEscalationMatrix,
} from "../../services/escalationMatrix/EscalationMatrixService";
import { Loading } from "../../services/Loading";
import {
  Stack,
  Text,
  PrimaryButton,
  Fabric,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  DefaultButton,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight, mdiDotsVertical } from "@mdi/js";
import NoDataTitle from "../common/NoDataTile";
import ManageEscalationMatrix from "./ManageEscalationMatrix";
import {
  childrenGap8,
  EMATRIX_DIC,
  EMATRIX_LEVELS_DICT,
  EMATRIX_ROLE_DIC,
} from "../common/Constants";
import { ToastContext } from "../common/ToastProvider";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";

export interface EscalationMatrixMainProps {
  dataCenter: IDataCenter;
}

const EscalationMatrixMain: React.FC<EscalationMatrixMainProps> = ({
  dataCenter,
}) => {
  //state
  const [state, setState] = React.useState({
    escalationMatrixs: [],
    manageEmDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    isLoading: false,
    isDataLoaded: false,
    search: {
      datacenterId: dataCenter._id,
      offset: 0,
      limit: 20,
    },
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      index: undefined,
      data: undefined,
    },
  } as {
    escalationMatrixs: IEscalationMatrix[];
    manageEmDialog: {
      isOpen: boolean;
      index?: number;
      data?: IEscalationMatrix;
    };
    isLoading: boolean;
    isDataLoaded: boolean;
    search: {
      datacenterId: string;
      offset: number;
      limit: number;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IEscalationMatrix;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  React.useEffect(() => {
    const asynFunc = async () => {
      await getEscalationMatrix(state.search);
    };
    asynFunc();
    // console.log("state", state);
  }, []);

  const getEscalationMatrix = async (searchObj: any) => {
    setState({ ...state, isLoading: true });
    let result = await getAllEscalationMatrix(searchObj);
    if (result && result.success) {
      setState({
        ...state,
        escalationMatrixs: result.data,
        isLoading: false,
        search: searchObj,
      });
    } else {
      showToast(
        result.message || "Error while getting Escalation Matrix",
        "error"
      );
      setState({ ...state, isLoading: false });
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let escalationMatrix = undefined;
    if (index !== undefined) {
      escalationMatrix = { ...state.escalationMatrixs[index] };
    }
    setState({
      ...state,
      manageEmDialog: {
        isOpen: true,
        index: index,
        data: escalationMatrix,
      },
    });
  };

  const handleDialogClose = (data: IEscalationMatrix) => {
    let escalationMatrix = [...state.escalationMatrixs];
    if (data) {
      if (state.manageEmDialog.index !== undefined) {
        escalationMatrix[state.manageEmDialog.index] = data;
        showToast("Escalation matrix updated successfully", "success");
      } else {
        escalationMatrix.unshift(data);
        showToast("Escalation matrix added successfully", "success");
      }
    }
    setState({
      ...state,
      manageEmDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      escalationMatrixs: escalationMatrix,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteAEm = async (item: IEscalationMatrix, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete escalation matrix",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteEscalationMatrix(item);
        if (result.success) {
          showToast("Escalation matrix deleted successfully", "success");
          let escalationMatrixs = [...state.escalationMatrixs];
          escalationMatrixs.splice(index, 1);
          setState({
            ...state,
            escalationMatrixs,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting escalation matrix",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={`Edit Escalation Matrix`}
          //     id={`editEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={`Delete Escalation Matrix`}
          //     id={`deleteEm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteAEm(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "role":
        return <span>{EMATRIX_ROLE_DIC[item.role]}</span>;
      case "type":
        return <span>{EMATRIX_DIC[item.type]}</span>;
      case "level":
        return <span>{EMATRIX_LEVELS_DICT[item.level]}</span>;
      case "name":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const onNextOrPrevFunc = async (isNext: boolean) => {
    let searchObj = { ...state.search };
    if (isNext) {
      searchObj.offset = searchObj.offset + searchObj.limit;
    } else {
      searchObj.offset = searchObj.offset - searchObj.limit;
    }
    await getEscalationMatrix(searchObj);
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IEscalationMatrix
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack className="pt-8">
        <Stack.Item>
          <Stack horizontal wrap horizontalAlign="end">
            {/* <Stack.Item className="ml-6">
              <span
                onClick={
                  state.search.offset === 0
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.search.offset === 0
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: "#135c8a",
                  }}
                />
                <DefaultButton
                  text="Previous"
                  className="borderless-btn"
                  // disabled={state.search.offset === 0}
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.escalationMatrixs.length < state.search.limit
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.escalationMatrixs.length < state.search.limit
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next"
                  className="borderless-btn"
                  // disabled={state.escalationMatrixs.length < state.search.limit}
                  // onClick={() => {
                  //   onNextOrPrevFunc(true);
                  // }}
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
                />
              </span>
            </Stack.Item> */}
            <Stack.Item>
              <PrimaryButton
                text="Add Escalation Matrix"
                onClick={() => handleDialogOpen(true)}
                className="borderless-btn bg-white"
              />
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <br />
        <Stack.Item>
          <div>
            {state.escalationMatrixs && state.escalationMatrixs.length > 0 ? (
              <Fabric>
                <Stack.Item>
                  <DetailsList
                    items={state.escalationMatrixs}
                    columns={[
                      {
                        key: "name",
                        name: "Name",
                        fieldName: "name",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "email",
                        name: "Email",
                        fieldName: "email",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "phone",
                        name: "Phone",
                        fieldName: "phone",
                        minWidth: 150,
                        maxWidth: 250,
                        isResizable: true,
                      },
                      {
                        key: "role",
                        name: "Function",
                        // name: "Role",
                        fieldName: "role",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "type",
                        name: "Role",
                        // name: "Type",
                        fieldName: "type",
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                      },
                      {
                        key: "level",
                        name: "Level",
                        fieldName: "level",
                        minWidth: 90,
                        maxWidth: 140,
                        isResizable: true,
                      },
                      {
                        key: "actions",
                        name: "Actions",
                        fieldName: "actions",
                        minWidth: 80,
                        maxWidth: 130,
                        isResizable: true,
                      },
                    ]}
                    onRenderItemColumn={_renderItemColumn as any}
                    compact={true}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    onRenderRow={_onRenderRow}
                  />
                </Stack.Item>
              </Fabric>
            ) : (
              <NoDataTitle title="No Escalation Matrix Found"></NoDataTitle>
            )}
          </div>
        </Stack.Item>
        <br />
        <Stack.Item className="mr-6" align="end">
          <span
            onClick={
              state.search.offset === 0
                ? undefined
                : () => onNextOrPrevFunc(false)
            }
            className={
              state.search.offset === 0 ? "btn-disabled" : "btn-enabled pointer"
            }
          >
            <Icon
              path={mdiChevronLeft}
              size={0.9}
              className="btnIcon"
              style={{
                marginBottom: -6,
                marginRight: -8,
                color: "#135c8a",
              }}
            />
            <DefaultButton
              text="Previous"
              className="borderless-btn"
            // disabled={state.search.offset === 0}
            // onClick={() => {
            //   onNextOrPrevFunc(false);
            // }}
            />
          </span>
          <span className="nxt-prv-btn-border"></span>
          <span
            onClick={
              state.escalationMatrixs.length < state.search.limit
                ? undefined
                : () => onNextOrPrevFunc(true)
            }
            className={
              state.escalationMatrixs.length < state.search.limit
                ? "btn-disabled"
                : "btn-enabled pointer"
            }
          >
            <DefaultButton
              text="Next"
              className="borderless-btn"
            // disabled={state.escalationMatrixs.length < state.search.limit}
            // onClick={() => {
            //   onNextOrPrevFunc(true);
            // }}
            />
            <Icon
              path={mdiChevronRight}
              size={0.9}
              className="btnIcon"
              style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
            />
          </span>
        </Stack.Item>
        {/* <Stack.Item>
          <div className="next-prev-btn">
            <div>
              <DefaultButton
                text="Previous"
                className="mr-8"
                disabled={state.search.offset === 0}
                onClick={() => {
                  onNextOrPrevFunc(false);
                }}
              />
              <DefaultButton
                text="Next"
                disabled={state.escalationMatrixs.length < state.search.limit}
                onClick={() => {
                  onNextOrPrevFunc(true);
                }}
              />
            </div>
          </div>
        </Stack.Item> */}
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteAEm(
                    state.manageActionsCallout.data as IEscalationMatrix,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageEmDialog.isOpen && (
        <ManageEscalationMatrix
          data={state.manageEmDialog.data}
          datacenterId={dataCenter._id as string}
          handleLoading={handleLoading}
          handleDialogclose={(data: IEscalationMatrix) =>
            handleDialogClose(data)
          }
        />
      )}
    </React.Fragment>
  );
};

export default EscalationMatrixMain;
